<template>
  <detail-page :breadcrumb="false">
    <template #content>
      <div class="content">
        <div class="text">
          <div>找不到指定内容(╥╯^╰╥)</div>
          <div><span @click="back">返回主页</span></div>
        </div>
      </div>
    </template>
  </detail-page>
</template>

<script>
import DetailPage from '@/views/mobile/components/detailPage/Index.vue'

export default {
  name: 'Mobile404',
  components: {
    DetailPage,
  },
  methods: {
    back() {
      this.$router.push({ name: 'MobileHome' })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin: 0 auto;
  padding: 15vw 4.8vw 30vw;
  width: 100%;

  .text {
    display: flex;
    flex-direction: column;
    text-align: center;
    font-size: 4.8vw;
    color: #515151;

    div {
      display: block;
      margin-bottom: 3vw;
    }

    span {
      font-size: 4vw;
      cursor: pointer;
    }
  }
}
</style>